import { useQuery } from "@apollo/client"
import { GET_SINGLE_PLAN_BY_ID } from "../graphql/queries/getSingleplanById"

export const useSinglePlanById = (id: number, resolution: string, from: any, to: any) => {
  const { data, error, loading, refetch } = useQuery(GET_SINGLE_PLAN_BY_ID, {
    variables: {
      id: id,
      resolution: resolution,
      fromTimeStamp: from,
      toTimeStamp: to,
    },
  })
  return { singlePlan: data?.singlePlan, error, loading, refetch }
}
